/**
 * Test-modus detectie voor visuele regressietests.
 *
 * Activeert een deterministische render:
 *   • Hero toont de statische poster i.p.v. de loopende <video>.
 *   • Framer-Motion entrance-animaties starten direct in eindstaat.
 *   • Oneindige animaties (pulse-glow, shimmer) worden overgeslagen.
 *
 * Activeer met één van:
 *   • Query string:    `?testMode=1`
 *   • localStorage:    `localStorage.setItem("lovable_test_mode", "1")`
 *   • Globale flag:    `window.__LOVABLE_TEST_MODE__ = true`
 *   • Automation:      `navigator.webdriver === true` (Playwright/Selenium)
 *
 * SSR-veilig: retourneert `false` zonder window.
 */
export const isTestMode = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    const w = window as Window & { __LOVABLE_TEST_MODE__?: boolean };
    if (w.__LOVABLE_TEST_MODE__ === true) return true;
    if (typeof navigator !== "undefined" && navigator.webdriver === true) return true;
    if (window.location?.search?.includes("testMode=1")) return true;
    if (window.localStorage?.getItem("lovable_test_mode") === "1") return true;
  } catch {
    /* localStorage kan in sandboxed iframes throwen — negeren */
  }
  return false;
};

export default isTestMode;
